import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useApp } from '../contexts/AppContext';

const ProtectedRoute = ({ children }) => {
  const { state } = useApp();
  const location = useLocation();

  console.log('ProtectedRoute - isAuthenticated:', state.auth.isAuthenticated);
  console.log('ProtectedRoute - loading:', state.auth.loading);
  console.log('ProtectedRoute - user:', state.auth.user);

  // Attendre la vérification d'authentification avant de rediriger
  if (state.auth.loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (!state.auth.isAuthenticated) {
    // Rediriger vers login en gardant en mémoire la page demandée
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute; 